var EventEmitter = require('events').EventEmitter;
var Dispatcher = require('./Dispatcher');
var assign = require('object-assign');

/**
 * Store class
 */


  /**
   * Constructs a Store object, extends it with EventEmitter and supplied
   * methods parameter,  and creates a mixin property for use in components.
   *
   * @param {object} methods - Public methods for Store instance
   * @param {function} callback - Callback method for Dispatcher dispatches
   * @constructor
   */
  function Store(methods, callback) {"use strict";
    var self = this;
    this.callback = callback;
    assign(this, EventEmitter.prototype, methods);
    this.mixin = {
      componentDidMount: function() {
        self.addChangeListener(this.onChange);
      },
      componentWillUnmount: function() {
        self.removeChangeListener(this.onChange);
      }
    }
  }

  /**
   * Emits change event
   */
  Store.prototype.emitChange=function() {"use strict";
    this.emit('change');
  };

  /**
   * Adds a change listener
   *
   * @param {function} callback - Callback method for change event
   */
  Store.prototype.addChangeListener=function(callback) {"use strict";
    this.on('change', callback);
  };

  /**
   * Removes a change listener
   *
   * @param {function} callback - Callback method for change event
   */
  Store.prototype.removeChangeListener=function(callback) {"use strict";
    this.removeListener('change', callback);
  };



module.exports = Store;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mcfly/lib/Store.js
 ** module id = 22
 ** module chunks = 0
 **/